import React from "react";
import classNames from "classnames";

import { withStyles } from '@material-ui/core/styles';

import ClaimCard from "../../ClaimCard";
import Scrollbars from "react-custom-scrollbars";

const styles = () => ({
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    overflowYy: "scroll"
  }
});

const ClaimsList = ({
  classes,
  className,
  claimCardsData,
  toggleCardExpansion,
  handleResolveClaim,
  handleDeleteClaim
}) => {
  return (
    <Scrollbars
      className={classNames(classes.root, className)}
      autoHide
      autoHideTimeout={1000}
      autoHideDuration={200}
    >
      {claimCardsData.length > 0 ? (
        claimCardsData.map((claimCard, i) => (
          <div key={i} className={classes.claimCard}>
            <ClaimCard
              className={classes.claimCard}
              key={claimCard.id}
              id={claimCard.id}
              index={i}
              expanded={claimCard.expanded}
              data={claimCard.data}
              handleResolveClaim={handleResolveClaim}
              handleDeleteClaim={handleDeleteClaim}
              toggleExpansion={toggleCardExpansion}
            />
          </div>
        ))
      ) : (
        <h1 style={{ textAlign: "center" }}>
          Nu exista cereri de internare active introduse
        </h1>
      )}
    </Scrollbars>
  );
};

export default withStyles(styles)(ClaimsList);
